interface Product {
  id: number;
  name: string;
  category: string;
  price: number;
  originalPrice: number;
  image: string;
  brand: string;
  region: string;
  rating: number;
  reviews: number;
  tags: string[];
  badge: string;
}

interface ProductCardProps {
  product: Product;
}

export default function ProductCard({ product }: ProductCardProps) {
  const discount = Math.round((1 - product.price / product.originalPrice) * 100);

  return (
    <div className="group cursor-pointer" data-product-shop>
      <div className="relative overflow-hidden rounded-lg bg-background-100 aspect-square">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {product.badge && (
          <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
            {product.badge}
          </span>
        )}
        {discount > 0 && (
          <span className="absolute top-3 right-3 px-2 py-0.5 bg-foreground-900/70 text-background-50 text-xs rounded whitespace-nowrap">
            -{discount}%
          </span>
        )}
      </div>
      <div className="mt-3 px-0.5">
        <div className="flex items-center gap-2 text-xs text-foreground-400 mb-1.5">
          <span>{product.brand}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
          <span>{product.region}</span>
        </div>
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
          {product.name}
        </h3>
        <div className="flex items-center gap-2 mt-2">
          <span className="text-base font-semibold text-accent-600 whitespace-nowrap">
            ¥{product.price.toLocaleString()}
          </span>
          {product.originalPrice > product.price && (
            <span className="text-xs text-foreground-300 line-through whitespace-nowrap">
              ¥{product.originalPrice.toLocaleString()}
            </span>
          )}
        </div>
        <div className="flex items-center gap-1.5 mt-1.5">
          <div className="flex items-center text-xs text-primary-500">
            {Array.from({ length: 5 }).map((_, i) => (
              <i key={i} className={`text-[10px] ${i < Math.floor(product.rating) ? 'ri-star-fill' : 'ri-star-line'}`}></i>
            ))}
          </div>
          <span className="text-xs text-foreground-400">({product.reviews})</span>
        </div>
        {product.tags.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mt-2">
            {product.tags.map((tag) => (
              <span key={tag} className="px-2 py-0.5 bg-secondary-100 text-secondary-800 text-[11px] rounded-full whitespace-nowrap">
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}